<dt-modal-content (closeClick)="modal.close()">
  <ng-template #title i18n>Zu Entscheidungsnavi {{ targetModeName }} wechseln</ng-template>
  <ng-template #content>
    <p i18n
      >Möchtest Du mit Deinem Projekt ins Entscheidungsnavi {{ targetModeName }} wechseln? Dadurch wird weitere Funktionalität im
      Entscheidungsnavi freigeschaltet.</p
    >
    <div class="warning-container">
      <mat-icon>warning_amber</mat-icon>
      <p i18n>Du kannst danach nicht wieder ins Entscheidungsnavi Starter zurückwechseln.</p>
    </div>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="modal.close(true)" data-cy="confirm-leave-starter" i18n>Ja, wechseln</button>
    <button mat-raised-button color="accent-less" (click)="modal.close(false)" i18n>Nein</button>
  </ng-template>
</dt-modal-content>
